"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconImage = exports.StyledIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const calcSize_1 = require("./helpers/calcSize");
exports.StyledIcon = styled_components_1.default.span `
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: ${({ size }) => (0, calcSize_1.calcSize)(size)};
    height: ${({ size }) => (0, calcSize_1.calcSize)(size)};
    min-width: ${({ size }) => (0, calcSize_1.calcSize)(size)};
    min-height: ${({ size }) => (0, calcSize_1.calcSize)(size)};
    overflow: hidden;

    svg {
        display: block;
        width: 100%;
        height: 100%;
    }

    ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
            filter: grayscale(100%);
            opacity: 0.5;
        `}
`;
exports.StyledIconImage = styled_components_1.default.i `
    display: block;
    overflow: hidden;
    padding: 0;
    margin: 0;
    background-color: transparent;
    background-image: ${({ src }) => (typeof src === 'string' ? `url(${src})` : '')};
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

    ${({ size }) => (0, styled_components_1.css) `
        width: ${(0, calcSize_1.calcSize)(size)};
        min-height: ${(0, calcSize_1.calcSize)(size)};
        height: ${(0, calcSize_1.calcSize)(size)};
    `}
`;
//# sourceMappingURL=Icon.styles.js.map